import { Record as record } from 'immutable';

import { construct, fields } from '../helpers/LinkMapper';

const defaults = {
    numberOfTickets: 0,
    text: ''
};

class CarnetInformation extends record(defaults) {

    static fromJSON (json = {}) {
        return construct(CarnetInformation, json, {
            numberOfTickets: fields.number,
            text: fields.string
        });
    }
}


export default CarnetInformation;
